import { render, staticRenderFns } from "./KoioteImageSwitchCanvasProperties.vue?vue&type=template&id=a2091e8e&lang=es&"
import script from "./KoioteImageSwitchCanvasProperties.vue?vue&type=script&lang=js&"
export * from "./KoioteImageSwitchCanvasProperties.vue?vue&type=script&lang=js&"
import style0 from "./KoioteImageSwitchCanvasProperties.vue?vue&type=style&index=0&id=a2091e8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports